// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"157":"01d038ff","917":"122afabb"}[chunkId] + ".chunk.css";
};